import { useState } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { renderDropdown, handleInputChange } from "./utils";
import { GanttChart } from "./GanttChart";

export const Details = () => {
  const [productSize, setProductSize] = useState("Small");
  const [fragile, setFragile] = useState("Yes");
  const [productWeight, setProductWeight] = useState("Light");
  const [margin, setMargin] = useState("Light");
  const [liquid, setLiquid] = useState("Yes");
  const [shelfLife, setShelfLife] = useState("High");
  const [activeDiscount, setActiveDiscount] = useState(5);
  const [price, setPrice] = useState(29.99);
  const [coupon, setCoupon] = useState(0);
  const [cogs, setCogs] = useState(4.7);
  const [dropdownOpen, setDropdownOpen] = useState<string | null>(null);
  const [showTable, setShowTable] = useState(false);

  const handleDiscountClick = (discount: number) => {
    setActiveDiscount(discount);
  };

  return (
    <div className={styles.details}>
      <div className={styles.priceWrapper}>
        <div className={styles.priceBox}>
          <span>Price</span>
          <div className={classNames(styles.inptWrapper, styles.price)}>
            <input
              type="text"
              id="productLaunchName"
              placeholder="Enter product name"
              className={styles.inpt}
              onChange={handleInputChange(setPrice)}
              value={price}
            />
          </div>
        </div>
        <div className={styles.subBox}>
          <span>Subscribe & Save discount</span>
          <div className={styles.subBox__btns}>
            {[5, 10, 15].map((discount) => (
              <button
                key={discount}
                className={classNames(styles.btnSub, {
                  [styles.active]: activeDiscount === discount,
                })}
                onClick={() => handleDiscountClick(discount)}
              >
                {discount}%
              </button>
            ))}
          </div>
        </div>
        <div className={styles.couponBox}>
          <span>Coupon</span>
          <div className={classNames(styles.inptWrapper, styles.price)}>
            <input
              type="text"
              id="coupon"
              placeholder="Enter product name"
              className={styles.inpt}
              onChange={handleInputChange(setCoupon)}
              value={coupon}
            />
          </div>
        </div>
        <div className={styles.cogsBox}>
          <span>COGS</span>
          <div className={classNames(styles.inptWrapper, styles.price)}>
            <input
              type="text"
              id="cogs"
              placeholder="Enter product name"
              className={styles.inpt}
              value={cogs}
              onChange={handleInputChange(setCogs)}
            />
          </div>
        </div>
      </div>
      <div className={styles.statsTray}>
        <div className={styles.score}>
          <h2>Opportunity Score</h2>
          <span className={styles.value}>
            2 <span className={styles.desc}>(Medium demand)</span>
          </span>
        </div>
        <div className={styles.sales}>
          <h2>Sales</h2>
          <span className={styles.value}>$2,8542.37</span>
        </div>
        <div className={styles.contribution}>
          <h2>Contribution Margin</h2>
          <span className={styles.value}>44.6%</span>
        </div>
        <div className={styles.roi}>
          <h2>ROI</h2>
          <span className={styles.value}>674%</span>
        </div>
      </div>
      <div className={styles.additional}>
        <h2>Additional Details</h2>
        <div className={styles.additional__wrapper}>
          <div className={styles.col}>
            {renderDropdown(
              "Product Size",
              productSize,
              "productSize",
              ["Small", "Medium", "Large"],
              dropdownOpen,
              setDropdownOpen,
              setProductSize,
            )}
            {renderDropdown(
              "Fragile",
              fragile,
              "fragile",
              ["Yes", "No"],
              dropdownOpen,
              setDropdownOpen,
              setFragile,
            )}
          </div>
          <div className={styles.col}>
            {renderDropdown(
              "Product Weight",
              productWeight,
              "productWeight",
              ["Light", "Medium", "Heavy"],
              dropdownOpen,
              setDropdownOpen,
              setProductWeight,
            )}
            {renderDropdown(
              "Margin (ROI)",
              margin,
              "margin",
              ["Low", "Medium", "High"],
              dropdownOpen,
              setDropdownOpen,
              setMargin,
            )}
          </div>
          <div className={styles.col}>
            {renderDropdown(
              "Liquid",
              liquid,
              "liquid",
              ["Yes", "No"],
              dropdownOpen,
              setDropdownOpen,
              setLiquid,
            )}
            {renderDropdown(
              "Shelf life",
              shelfLife,
              "shelfLife",
              ["Low", "Medium", "High"],
              dropdownOpen,
              setDropdownOpen,
              setShelfLife,
            )}
          </div>
        </div>
      </div>
      <button className={styles.save} onClick={() => setShowTable(true)}>
        Save
      </button>
      {showTable && <GanttChart />}
    </div>
  );
};
